import { render, staticRenderFns } from "./attribute.vue?vue&type=template&id=bc84cbce&scoped=true&"
import script from "./attribute.vue?vue&type=script&lang=js&"
export * from "./attribute.vue?vue&type=script&lang=js&"
import style0 from "./attribute.vue?vue&type=style&index=0&id=bc84cbce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc84cbce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc84cbce')) {
      api.createRecord('bc84cbce', component.options)
    } else {
      api.reload('bc84cbce', component.options)
    }
    module.hot.accept("./attribute.vue?vue&type=template&id=bc84cbce&scoped=true&", function () {
      api.rerender('bc84cbce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/exhibit/attribute.vue"
export default component.exports